import { render, staticRenderFns } from "./DashboardServicosVisaoAneelCardSituacaoSolicitacoes.vue?vue&type=template&id=730547c9&"
import script from "./DashboardServicosVisaoAneelCardSituacaoSolicitacoes.vue?vue&type=script&lang=js&"
export * from "./DashboardServicosVisaoAneelCardSituacaoSolicitacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports